import styled from 'styled-components';

export const ContactStyle = styled.div`
  .buttons-wrapper {
    &__item {
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 24px;
      }
    }
  }
`;
